<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          <v-row>
            <v-col cols="6" md="6" lg="6" style="text-align: start">
              Search Car Information
            </v-col>
            <v-col cols="6" md="6" lg="6" style="text-align: end"> </v-col>
          </v-row>
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-bottom: 2%; margin-top: 2%"
            >
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-row dense>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-text-field
                            label="Transaction Entry"
                            append-icon="mdi-database-search-outline"
                            v-model="logEntry"
                            clearable
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-text-field
                            label="License Plate"
                            append-icon="mdi-database-search-outline"
                            v-model="carNo"
                            clearable
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-select
                            :items="['Car', 'Motorcycle']"
                            label="Vehicle Type"
                            v-model="vehicleType"
                            required
                            clearable
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-text-field
                            label="Ticket No"
                            append-icon="mdi-database-search-outline"
                            v-model="ticketNo"
                            clearable
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-autocomplete
                            :items="tenantArray"
                            item-value="tenantID"
                            item-text="tenantName"
                            label="Tenant"
                            v-model="SearchTenant"
                            required
                            clearable
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-select
                            :items="['ยังอยู่ในระบบ', 'ออกจากระบบ']"
                            label="Exit Status"
                            v-model="statusLog"
                            required
                            clearable
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-divider class="my-1"></v-divider>
                      <v-row dense class="mt-5">
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0">
                          <v-menu
                            v-model="menuStartDateEntry"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="EntryStartDateDisplay"
                                label="Entry Date Start"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="entryDateStart"
                              @change="menuStartDateEntry = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0">
                          <v-dialog
                            ref="dialogStartTimeEntry"
                            v-model="menuStartTimeEntry"
                            :return-value.sync="startTimeEntry"
                            persistent
                            width="300px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="startTimeEntry"
                                label="Entry Time Start"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                dense
                                clearable
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="startTimeEntry"
                              full-width
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menuStartTimeEntry = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.dialogStartTimeEntry.save(
                                    startTimeEntry
                                  )
                                "
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0">
                          <v-menu
                            v-model="menuEndDateEntry"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="EntryEndDateDisplay"
                                label="Entry Date End"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="entryDateEnd"
                              @change="menuEndDateEntry = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0">
                          <v-dialog
                            ref="dialogEndTimeEntry"
                            v-model="menuEndTimeEntry"
                            :return-value.sync="endTimeEntry"
                            persistent
                            width="300px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endTimeEntry"
                                label="Entry Time End"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                dense
                                clearable
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="endTimeEntry"
                              full-width
                              :allowed-hours="(hour) => hour !== 0"
                              :allowed-minutes="(minute) => true"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menuEndTimeEntry = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.dialogEndTimeEntry.save(endTimeEntry)
                                "
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-menu
                            v-model="menuStartDateExit"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="ExitStartDateDisplay"
                                label="Exit Date Start"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="exitDateStart"
                              @change="menuStartDateExit = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-dialog
                            ref="dialogStartTimeExit"
                            v-model="menuStartTimeExit"
                            :return-value.sync="startTimeExit"
                            persistent
                            width="300px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="startTimeExit"
                                label="Exit Time Start"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                dense
                                clearable
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="startTimeExit"
                              full-width
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menuStartTimeExit = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.dialogStartTimeExit.save(startTimeExit)
                                "
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-menu
                            v-model="menuEndDateExit"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="ExitEndDateDisplay"
                                label="Exit Date End"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="exitDateEnd"
                              @change="menuEndDateExit = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2" class="py-0 my-0">
                          <v-dialog
                            ref="dialogEndTimeExit"
                            v-model="menuEndTimeExit"
                            :return-value.sync="endTimeExit"
                            persistent
                            width="300px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="endTimeExit"
                                label="Exit Time End"
                                append-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                dense
                                clearable
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              format="24hr"
                              v-model="endTimeExit"
                              full-width
                              :allowed-hours="(hour) => hour !== 0"
                              :allowed-minutes="(minute) => true"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menuEndTimeExit = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.dialogEndTimeExit.save(endTimeExit)
                                "
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                      <v-divider class="my-1"></v-divider>
                      <v-row dense class="mt-2">
                        <v-col cols="12" sm="6" md="2" lg="2">
                          <v-autocomplete
                            :items="DropdownTerminalIn"
                            item-value="terminalID"
                            item-text="terminalName"
                            label="Entry Gate"
                            v-model="terminalIDIn"
                            required
                            clearable
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2">
                          <v-autocomplete
                            :items="DropdownTerminalOut"
                            item-value="terminalID"
                            item-text="terminalName"
                            label="Exit Gate"
                            v-model="terminalIDOut"
                            required
                            clearable
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" lg="2">
                          <v-select
                            :items="['Member', 'Visitor']"
                            label="Member Type"
                            v-model="memType"
                            required
                            clearable
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                          cols="12"
                          md="12"
                          lg="12"
                          style="text-align: end"
                        >
                          <v-btn
                            :color="'blue'"
                            class="ma-2 white--text"
                            @click="SearchgetDataTransactionCarpark()"
                          >
                            Search

                            <v-icon right> mdi-magnify </v-icon>
                          </v-btn>
                          <v-btn
                            color="green"
                            class="ma-2 white--text"
                            @click="ExportTransactionCarpark()"
                          >
                            Export Excel
                            <v-icon right>mdi-file-excel-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>

            <v-card
              elevation="10"
              style="
                padding-left: 2%;
                margin-top: 2%;
                margin-bottom: 2%;
                padding-right: 2%;
              "
            >
              <v-row>
                <v-col cols="12" md="6"></v-col>
                <v-col cols="12" md="6" align="center">
                  <v-pagination
                    v-model="page"
                    :total-visible="8"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  >
                  </v-pagination>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="DataList"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-center-css">
                      {{ no_run + (index + 1) }}
                    </td>
                    <td class="header-table-center-css">{{ item.logEntry }}</td>
                    <td class="header-table-center-css">{{ item.carNo }}</td>
                    <td class="header-table-center-css">
                      {{ item.tenantName == null ? "" : item.tenantName }}
                    </td>
                    <td class="header-table-center-css">
                      {{
                        item.memberType == 0
                          ? "Visitor"
                          : item.memberType == 1
                          ? "Member"
                          : ""
                      }}
                    </td>
                    <td class="header-table-center-css">
                      {{ ChangeFormatDate(item.entryDate) }}
                    </td>
                    <td class="header-table-center-css">
                      {{ ChangeFormatDate(item.exitDate) }}
                    </td>
                    <td class="header-table-center-css">
                      {{ item.vehicleType == 0 ? "Car" : "Motorcycle" }}
                    </td>
                    <td class="header-table-center-css">
                      {{ item.ticketNo }}
                    </td>
                    <td class="header-table-center-css">
                      {{ ConvertTerminalID(item.terminalEntry) }}
                    </td>
                    <td
                      v-if="item.terminalExit != '0'"
                      class="header-table-center-css"
                    >
                      {{ ConvertTerminalID(item.terminalExit) }}
                    </td>
                    <td
                      v-if="item.terminalExit == '0'"
                      class="header-table-center-css"
                    >
                      <v-dialog
                        transition="dialog-top-transition"
                        max-width="600"
                        persistent
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="error"
                            v-bind="attrs"
                            :disabled="
                              permissionsPage.read &&
                              !(
                                permissionsPage.update || permissionsPage.create
                              )
                            "
                            v-on="on"
                            @click="getDataForceOutByLogID(item.logEntry)"
                          >
                            FORCE OUT
                          </v-btn>
                        </template>
                        <template v-slot:default="dialogForceOut">
                          <v-card>
                            <v-toolbar color="primary" dark
                              >FORCE OUT BY</v-toolbar
                            >
                            <v-card-text>
                              <div
                                class="text-h3 pa-12"
                                style="display: flex; justify-content: center"
                              >
                                {{
                                  userForceout == null
                                    ? "Data Not Found"
                                    : userForceout
                                }}
                              </div>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                              <v-btn text @click="dialogForceOut.value = false"
                                >Done</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>

                      <!-- <v-btn color="error" @click="getDataForceOutByLogID(item.logEntry)"> FORCE OUT </v-btn> -->
                    </td>

                    <td style="text-align: center; min-width: 150px">
                      <v-btn
                        v-if="permissionsPage.read"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="blue"
                        @click="getDataTransactionCarparkByLogID(item.logEntry)"
                      >
                        <v-icon dark> mdi mdi-eye </v-icon>
                      </v-btn>

                      <v-btn
                        v-if="permissionsPage.update"
                        class="mx-2"
                        fab
                        small
                        color="red"
                        :disabled="item.exitStatus == 1"
                        @click="OpenDialogForce(item.logEntry)"
                      >
                        <v-icon style="color: white">
                          mdi-location-exit
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="8"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3" style="padding-left: 180px">
                  <div class="input-container">
                    <v-text-field
                      v-model="pageSearch"
                      label="Page"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      @click="ChangePageSearch(pageSearch)"
                    >
                      Go
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    label="10/page"
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="TransactionCarparkDialog"
      persistent
      max-width="1200px"
      scrollable
    >
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Parking Information</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row style="margin-top: 1%">
              <v-col cols="12" md="6" sm="6">
                <v-card class="mt-3 mx-auto" height="150">
                  <v-sheet
                    class="v-sheet--offset mx-auto"
                    color="green"
                    elevation="12"
                    max-width="calc(100% - 32px)"
                  >
                    <v-card-title
                      style="
                        color: white;
                        display: flex;
                        font-size: 18px;
                        justify-content: space-between;
                      "
                    >
                      <strong>License Plate</strong>Vehicle Type :
                      <div v-if="DataListCarparkID.vehicleType == 'Motorcycle'">
                        <v-icon style="color: white; font-size: 30px"
                          >mdi-motorbike</v-icon
                        >
                        <span class="ml-3">Motorcycle</span>
                      </div>
                      <div v-if="DataListCarparkID.vehicleType == 'Car'">
                        <v-icon style="color: white; font-size: 30px"
                          >mdi-car-estate</v-icon
                        >
                        <span class="ml-3">Car</span>
                      </div>
                    </v-card-title>
                  </v-sheet>

                  <v-card-subtitle>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        sm="12"
                        style="text-align: center; font-size: 60px"
                      >
                        <strong> {{ DataListCarparkID.carNo }}</strong>
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-card class="mt-3 mx-auto" height="150">
                  <v-sheet
                    class="v-sheet--offset mx-auto"
                    color="blue"
                    elevation="12"
                    max-width="calc(100% - 32px)"
                    height="70"
                  >
                    <v-card-title
                      style="
                        color: white;
                        display: flex;
                        font-size: 18px;
                        justify-content: space-between;
                      "
                    >
                      <strong>Transaction Entry Log</strong>
                      Status :
                      {{
                        DataListCarparkID.exitStatus == 0
                          ? "Still Remain"
                          : "Exit"
                      }}
                    </v-card-title>
                  </v-sheet>

                  <v-card-subtitle>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        sm="12"
                        style="text-align: center; font-size: 30px"
                      >
                        <strong> {{ DataListCarparkID.logID }}</strong>
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card class="mx-auto" elevation="10">
                  <v-card-title class="text-h6">
                    <strong>Parking Information</strong>
                  </v-card-title>
                  <v-card-subtitle>
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <span style="font-size: 18px; color: black"
                          >Entry Log: &nbsp;<span style="color: #666666">{{
                            DataListCarparkID.logID
                          }}</span></span
                        ><br />
                        <span style="font-size: 18px; color: black"
                          >Exit Log: &nbsp;<span style="color: #666666">{{
                            DataListCarparkID.logIDExit
                          }}</span></span
                        ><br />
                        <span style="font-size: 18px; color: black"
                          >Ticket No: &nbsp;<span style="color: #666666">{{
                            DataListCarparkID.ticketNo
                          }}</span></span
                        ><br />
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <span style="font-size: 18px; color: black">
                          Entry Date: &nbsp;<span style="color: #666666">{{
                            DataListCarparkID.entryDate
                          }}</span></span
                        ><br />
                        <span style="font-size: 18px; color: black">
                          Exit Date: &nbsp;<span style="color: #666666">{{
                            ChangeFormatDate(DataListCarparkID.exitDate)
                          }}</span></span
                        ><br />
                        <span style="font-size: 18px; color: black">
                          Parking Time: &nbsp;<span style="color: #666666">{{
                            DataListCarparkID.parkTime
                          }}</span></span
                        >
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="ImageList.length">
                <v-card class="mx-auto" elevation="10">
                  <v-card-title class="text-h6 font-weight-bold">
                    Parking Images
                  </v-card-title>
                  <v-card-subtitle>
                    <v-row v-for="item in ImageList" :key="item.id">
                      <v-col
                        v-for="img in [
                          { src: item.driverImage, label: 'Driver Image' },
                          {
                            src: item.licensePlateImage,
                            label: 'License Plate',
                          },
                          { src: item.lpR_Image, label: 'LPR Result' },
                          { src: item.idCard_Image, label: 'ID Card' },
                        ].filter((x) => x.src && x.src !== '')"
                        :key="img"
                        cols="12"
                        sm="3"
                        md="3"
                      >
                        <v-img
                          :src="img"
                          class="parking-img pointer"
                          @click="OpenImageCarpark(img)"
                          cover
                        />
                        <div class="mt-2 text-subtitle-2 font-weight-bold">
                          {{ img.label }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-row style="text-align: -webkit-center"> </v-row>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: right; margin-bottom: 20px"
            >
              <v-spacer></v-spacer>
              <v-btn
                v-if="permissionsPage.delete"
                variant="outlined"
                color="primary"
                style="min-width: 150px; color: white; margin-right: 20px"
                append-icon="mdi-close-circle-outline"
                @click="OpenQrImage(DataListCarparkID.logID)"
              >
                Reprint
              </v-btn>
              <v-btn
                variant="outlined"
                color="red"
                style="min-width: 150px; color: white"
                append-icon="mdi-close-circle-outline"
                @click="clear()"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="ShowImageDialog"
      width="95vw"
      max-width="1100px"
      persistent
    >
      <v-card class="pa-0 image-dialog">
        <v-btn
          icon
          color="white"
          class="close-btn"
          @click="CloseImageCarpark()"
        >
          <v-icon size="32">mdi-close</v-icon>
        </v-btn>

        <v-card-text>
          <v-container fluid>
            <v-row justify="center">
              <v-col cols="12" sm="10" md="10">
                <v-img :src="ShowImageText" class="preview-img" contain />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ShowReprintImageDialog" persistent width="800">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
              style="display: flex; justify-content: center; margin-top: 20px"
            >
              <v-card
                id="capture"
                elevation="7"
                height="750"
                style="
                  background-color: rgb(255, 255, 255) !important;
                  height: 700px;
                  page-break-after: always;
                  width: 350px;
                  padding: 0;
                "
              >
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff"
                >
                  <v-img
                    height="38"
                    width="400"
                    src="@/assets/logo-01.png"
                  ></v-img>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="
                    text-align: center;
                    padding: 0;
                    display: grid;
                    justify-content: space-evenly;
                    background-color: #fff;
                  "
                >
                  <qr-code
                    style="margin: 12px"
                    :size="180"
                    :text="qrImage"
                    error-level="M"
                  ></qr-code>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff"
                >
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col
                      cols="10"
                      md="10"
                      sm="10"
                      lg="10"
                      style="
                        text-align: center;
                        padding: 0;
                        background-color: #fff;
                      "
                    >
                      <label style="font-size: 16px">LogId : {{ logId }}</label>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff"
                >
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col
                      cols="10"
                      md="10"
                      sm="10"
                      lg="10"
                      style="
                        padding: 0;
                        background-color: #fff;
                        display: flex;
                        justify-content: space-between;
                        font-weight: 600;
                        color: black;
                      "
                    >
                      <label style="font-size: 16px"
                        >Ticket : {{ ticket }}</label
                      >
                      <label style="font-size: 16px"
                        >License : {{ license }}</label
                      >
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff"
                >
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col
                      cols="10"
                      md="10"
                      sm="10"
                      lg="10"
                      style="
                        padding: 0;
                        background-color: #fff;
                        display: flex;
                        justify-content: space-between;
                        font-weight: 600;
                        color: black;
                      "
                    >
                      <label style="font-size: 16px">Date : {{ date }}</label>
                      <label style="font-size: 16px">Time : {{ time }}</label>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="
                    background-color: #fff;
                    display: grid;
                    justify-content: space-evenly;
                    line-height: 1.3;
                    padding-top: 20px;
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="text-center"
                      md="12"
                      sm="12"
                      lg="12"
                      style="
                        padding: 0;
                        background-color: #fff;
                        font-weight: 600;
                        color: black;
                        text-align: center;
                      "
                    >
                      <hr
                        style="
                          width: auto;
                          margin-left: 30px !important;
                          margin-right: 30px !important;
                          font-weight: 400;
                        "
                      />
                      <label style="font-size: 13px">{{
                        "Please complete parking fees before exit"
                      }}</label>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      lg="12"
                      style="
                        padding: 0;
                        background-color: #fff;
                        text-align: center;
                        color: black;
                      "
                    >
                      <label style="font-size: 11px">{{
                        "โปรดตรวจสอบค่าบริการก่อนออกจากอาคารจอดรถ"
                      }}</label>
                      <hr
                        style="
                          width: auto;
                          margin-left: 30px !important;
                          margin-right: 30px !important;
                          font-weight: 400;
                        "
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff; padding-top: 15px"
                >
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col
                      cols="10"
                      md="10"
                      sm="10"
                      lg="10"
                      style="padding: 0; background-color: #fff"
                    >
                      <v-card-text
                        v-html="dialogText"
                        style="
                          font-size: 10px;
                          padding: 0;
                          line-height: 1.1;
                          color: black;
                        "
                      ></v-card-text>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  lg="12"
                  style="background-color: #fff; padding-top: 130px"
                >
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col
                      cols="10"
                      md="10"
                      sm="10"
                      lg="10"
                      style="padding: 0; background-color: #fff"
                    >
                      <label style="font-size: 10px">{{
                        "*100THB for re-printing parking ticket"
                      }}</label>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              md="6"
              sm="6"
              style="display: flex; justify-content: center"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    text-align: center;
                  "
                >
                  <v-btn
                    variant="outlined"
                    color="success"
                    class="mt-5"
                    style="margin: 10px; width: 150px; height: 150px"
                    @click="print()"
                  >
                    <v-icon> mdi-printer </v-icon>
                    Print
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    text-align: center;
                  "
                >
                  <v-btn
                    variant="outlined"
                    color="silver"
                    class="mt-5"
                    style="margin: 10px; width: 150px; height: 150px"
                    @click="ShowReprintImageDialog = false"
                  >
                    <v-icon> mdi-close-circle-outline </v-icon>
                    Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="DialogReprint" persistent scrollable max-width="1200px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Reprint Transaction</span>
        </v-card-title>
        <v-card-text>
          <ReprintComponent />
        </v-card-text>

        <v-card-actions style="background-color: #f9f9f9">
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: end; margin-bottom: 10px; margin-top: 10px"
            >
              <v-spacer></v-spacer>

              <v-btn
                variant="outlined"
                color="silver"
                style="min-width: 100px; background-color: white"
                append-icon="mdi-close-circle-outline"
                @click="DialogReprint = false"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ReprintComponent from "@/components/ReprintComponent";
import html2canvas from "html2canvas";
import { eventBus } from "../../main";

export default {
  name: "SearchCarInformation",
  components: {
    ReprintComponent,
  },
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      urlCarpark: enurl.apiCarparkUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      pageSearch: 1,
      itemsPerPage: 10,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",

      DataList: [],
      DataListCarparkID: [],
      DataListImgID: [],
      ConfigTerminal: [],
      DropdownConfigTerminal: [],
      DropdownTerminalIn: [],
      terminalIDIn: null,
      terminalIDOut: null,
      DropdownTerminalOut: [],
      ImageList: [],

      DriverImg: "",
      LicensePlateImg: "",
      LPRImg: "",

      search: "",

      TransactionCarparkDialog: false,
      EditStatus: false,
      ShowImageDialog: false,
      ShowReprintImageDialog: false,
      DialogReprint: false,
      ShowImageText: "",

      // Start Date Time Picker
      menuStartDateEntry: false,
      entryDateStart: "",

      menuStartTimeEntry: false,
      startTimeEntry: null,

      menuEndDateEntry: false,
      entryDateEnd: "",

      menuEndTimeEntry: false,
      endTimeEntry: null,

      // End Date Time Picker
      menuStartDateExit: false,
      exitDateStart: "",

      menuStartTimeExit: false,
      startTimeExit: null,

      menuEndDateExit: false,
      exitDateEnd: "",

      menuEndTimeExit: false,
      endTimeExit: null,

      Status: true,

      listType: "",
      text: "",
      vmsKiosk: "",
      stamp: "",

      logEntry: "",
      carNo: "",

      vehicleType: "",
      ticketNo: "",
      terminalEntry: "",
      statusLog: "",
      password: "",
      memType: "",

      permissionsPage: [],
      ExportButtonRolePermission: null,
      tenantArray: [],
      SearchTenant: "",
      dataExport: [],

      logId: "",
      qrImage: "",
      ticket: "",
      license: "",
      date: "",
      time: "",

      userForceout: "",

      dialogText:
        "Parking Payment Options<br/>1. Mobile Payment Scan QR code through mobile camera<br/>or One Bangkok application<br/>2. Kiosk Payment Scan QR cade at parking payment kiosk located at retail area<br/><br/>วิธีชำระค่าบริการ<br/>1. Mobile Payment สแกนQR codeด้านบนผ่านโทรศัพท์มือถือ หรือ<br/>One Bangkok แอพพลิเคชั่น<br/>2. Kiosk Payment นำบัตรจอดรถแสกนที่ตู้อัตโนมัติภายในศูนย์ฯ",

      columns: [
        {
          label: "",
          field: "LogEntry",
        },
        {
          label: "",
          field: "LicensePlate",
        },
        {
          label: "",
          field: "Tenant",
        },
        {
          label: "",
          field: "DatetimeIn",
        },
        {
          label: "",
          field: "DatetimeOut",
        },
        {
          label: "",
          field: "VehicleType",
        },
        {
          label: "",
          field: "TicketNo",
        },
        {
          label: "",
          field: "TerminalIn",
        },
        {
          label: "",
          field: "TerminalOut",
        },
      ],
    };
  },
  computed: {
    // validatePage() {
    //   return (value) => {
    //     if (value === null || value === "") return true;
    //     return value >= 1 && value <= this.pageCount
    //       ? true
    //       : `Enter a number between 1 and ${this.pageCount}`;
    //   };
    // },
    EntryStartDateDisplay() {
      if (!this.entryDateStart) return "";
      let [year, month, day] = this.entryDateStart.split("-");
      return `${day}-${month}-${year}`;
    },
    EntryEndDateDisplay() {
      if (!this.entryDateEnd) return "";
      let [year, month, day] = this.entryDateEnd.split("-");
      return `${day}-${month}-${year}`;
    },

    ExitStartDateDisplay() {
      if (!this.exitDateStart) return "";
      let [year, month, day] = this.exitDateStart.split("-");
      return `${day}-${month}-${year}`;
    },
    ExitEndDateDisplay() {
      if (!this.exitDateEnd) return "";
      let [year, month, day] = this.exitDateEnd.split("-");
      return `${day}-${month}-${year}`;
    },

    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "center",
        },
        {
          text: "Transaction Entry Log",
          align: "center",
          sortable: false,
        },
        {
          text: "License Plate",
          align: "center",
          sortable: false,
        },
        {
          text: "Tenant",
          align: "center",
          sortable: false,
        },
        {
          text: "MemberType",
          align: "center",
          sortable: false,
        },
        {
          text: "Entry date",
          align: "center",
          sortable: false,
        },
        {
          text: "Exit date",
          align: "center",
          sortable: false,
        },
        {
          text: "Vehicle Type",
          align: "center",
          sortable: false,
        },
        {
          text: "Ticket No",
          align: "center",
          sortable: false,
        },
        {
          text: "Entry gate",
          align: "center",
          sortable: false,
        },
        {
          text: "Exit gate",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;

    let date = new Date();
    let formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    this.entryDateStart = formattedDate;

    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    await self.getDataTransactionCarpark();
    await self.getMasConfigTerminal();
    await self.getDropdownSearchTerminal();
    await self.getTennant();
    // await self.ExportTransactionCarpark();
  },

  methods: {
    print() {
      let self = this;
      html2canvas(document.querySelector("#capture")).then((canvas) => {
        // document.body.appendChild(canvas)
        // console.log(document.body.appendChild(canvas));

        const base64 = canvas.toDataURL("image/png");

        // var myImage = canvas.toDataURL("image/png");
        var tWindow = window.open("");

        tWindow.document.body.appendChild(canvas);

        // focus on the window
        tWindow.focus();

        // print the window
        tWindow.print();

        // reload the page
        tWindow.close();

        // console.log(base64);
        self.base64 = base64;

        // self.ReSet();

        // window.print(self.base64);
        // self.printQr(self.base64);
        // var anchor = document.createElement("a");
        // anchor.setAttribute("href", base64);
        // anchor.setAttribute("download", "receipt.png");
        // anchor.click();
        // anchor.focus();
        // anchor.print();
        // anchor.remove();
      });
    },

    OpenQrImageindex(data) {
      let self = this;
      if (data != "") {
        // self.ShowImageText = data;
        self.qrImage = "https://carpark.onebangkok.com/info/" + data.logEntry;
        self.logId = data.logEntry;
        self.ticket = data.ticketNo;
        self.license = data.carNo;
        self.date = self.ChangeFormatDateOnly(data.entryDate);
        self.time = self.ChangeFormatTime(data.entryDate);
        self.ShowReprintImageDialog = true;
      }
    },

    OpenCardDialogReprint() {
      let self = this;
      self.DialogReprint = true;
    },

    OpenQrImage(data) {
      let self = this;
      if (data != "") {
        // self.ShowImageText = data;
        self.ShowReprintImageDialog = true;
      }
    },

    OpenImageCarpark(data) {
      let self = this;
      if (data != "") {
        self.ShowImageText = data;
        self.ShowImageDialog = true;
      }
    },

    CloseImageCarpark() {
      let self = this;
      self.ShowImageText = "";
      self.ShowImageDialog = false;
    },

    getTennant() {
      let self = this;
      axios
        .get(`${self.url}Tenant/getDataTenant`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.tenantArray = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    async getMasConfigTerminal() {
      let that = this;
      await axios
        .get(`${that.url}TransactionCarpark/getMasConfigTerminal`)
        .then(function (response) {
          if (response.data.status == 0) {
            that.ConfigTerminal = response.data.data;
            // console.log(response.data.data);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    async getDropdownSearchTerminal() {
      let that = this;
      await axios
        .get(`${that.url}TransactionCarpark/getDropdownSearchTerminal`)
        .then(function (response) {
          if (response.data.status == 0) {
            that.DropdownConfigTerminal = response.data.data;
            that.DropdownTerminalIn = response.data.data.terminalIn;
            that.DropdownTerminalOut = response.data.data.terminalOut;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ConvertTerminalID(value) {
      let self = this;
      if (value != null) {
        return self.ConfigTerminal.filter((x) => x.terminalID == value) == null
          ? ""
          : self.ConfigTerminal.filter((x) => x.terminalID == value)[0] == null
          ? ""
          : self.ConfigTerminal.filter((x) => x.terminalID == value)[0]
              .terminalName;
      }
    },

    async getDataTransactionCarpark() {
      let self = this;
      self.LoadingDialog = true;
      // self.page = 1;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,

        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,
        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        terminalIn: self.terminalIDIn == "" ? null : self.terminalIDIn,
        terminalOut: self.terminalIDOut === "" ? null : self.terminalIDOut,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      await axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.ExportButtonRolePermission = response.data.data.roleID;
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    async SearchgetDataTransactionCarpark() {
      let self = this;
      if (!self.entryDateStart && !self.exitDateStart) {
        Swal.fire({
          icon: "warning",
          width: 500,
          text: "กรุณาระบุวันที่เริ่มต้นที่ต้องการค้นหา",
        });
      }
      if (self.endTimeEntry != null && self.startTimeEntry != null) {
        if (self.endTimeEntry <= self.startTimeEntry) {
          Swal.fire({
            icon: "warning",
            width: 600,
            text: "วันที่และเวลาสิ้นสุดต้องไม่อยู่ก่อนวันที่และเวลาเริ่มต้น !",
          });
        }
      }
      if (self.endTimeExit != null && self.startTimeExit != null) {
        if (self.endTimeExit <= self.startTimeExit) {
          Swal.fire({
            icon: "warning",
            width: 600,
            text: "วันที่และเวลาสิ้นสุดต้องไม่อยู่ก่อนวันที่และเวลาเริ่มต้น !",
          });
        }
      }
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,

        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,

        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        terminalIn: self.terminalIDIn == "" ? null : self.terminalIDIn,
        terminalOut: self.terminalIDOut === "" ? null : self.terminalIDOut,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      await axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.ExportButtonRolePermission = response.data.data.roleID;
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      self.pageSearch = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,

        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,
        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        terminalIn: self.terminalIDIn == "" ? null : self.terminalIDIn,
        terminalOut: self.terminalIDOut === "" ? null : self.terminalIDOut,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePageSearch(value) {
      let self = this;
      self.LoadingDialog = true;
      value = parseInt(value);
      self.page = value;
      self.pageSearch = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,
        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,
        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        terminalIn: self.terminalIDIn == "" ? null : self.terminalIDIn,
        terminalOut: self.terminalIDOut === "" ? null : self.terminalIDOut,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      self.pageSearch = 1;
      let temp = {
        page: 1,
        perpage: value,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,
        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,
        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        terminalIn: self.terminalIDIn == "" ? null : self.terminalIDIn,
        terminalOut: self.terminalIDOut === "" ? null : self.terminalIDOut,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
    ChangeFormatDateOnly(date) {
      if (!date) return null;
      var DateData = new Date(date);
      // // var hours = DateData.getHours();
      // var minutes = DateData.getMinutes();
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear()
      );
    },
    ChangeFormatTime(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      var sec = DateData.getSeconds();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + ":" + sec;
      return strTime;
    },
    clear() {
      let self = this;
      self.ImageList = [];
      self.TransactionCarparkDialog = false;
    },

    GetColor(value) {
      if (value == "1") {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    async OpenDialogForce(log) {
      this.LoadingDialog = true;
      const { value: formValues } = await Swal.fire({
        showCloseButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        title: "ปรับสถานะออก",
        html: `
              <input id="swal-input1" type="password" class="swal2-input" placeholder="Password">
              <p style="color: red;text-align: center;">*กรอกรหัสยืนยันตัวตน </p>

            `,
        focusConfirm: false,
        preConfirm: () => {
          return [document.getElementById("swal-input1").value];
        },
      });
      if (formValues) {
        // console.log(formValues);
        this.password = formValues[0];
      }
      if (this.password == "") {
        this.LoadingDialog = false;
        // Swal.fire({
        //   icon: "warning",
        //   title: "Please fill in this form.",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
        return;
      } else {
        this.forceAntiPassBack(log);
      }
    },

    forceAntiPassBack(log) {
      let that = this;
      that.LoadingDialog = true;
      let temp = {
        logEntry: log,
        password: that.password,
      };
      axios
        .post(`${that.url}TransactionCarpark/forceAntiPassBack`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            that.LoadingDialog = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            that.getDataTransactionCarpark();
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.LoadingDialog = false;
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      that.LoadingDialog = false;
    },

    getDataTransactionCarparkByLogID(id) {
      let that = this;
      that.LoadingDialog = true;
      that.DataListCarparkID = [];
      that.DataListImgID = [];
      let temp = {
        logid: id,
      };
      axios
        .post(
          `${that.urlCarpark}TransactionCarpark/getDataTransactionCarparkByLogID`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            that.DataListCarparkID = response.data.data.transaction;
            // that.DataListImgID = response.data.data.picture;
            that.BindingEditData(that.DataListCarparkID);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.LoadingDialog = false;
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getDataForceOutByLogID(id) {
      let that = this;
      that.LoadingDialog = true;
      let temp = {
        logid: id,
      };
      axios
        .post(
          `${that.urlCarpark}TransactionCarpark/getDataTransactionCarparkByLogID`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            that.DataListCarparkID = response.data.data.transaction;
            that.userForceout = that.DataListCarparkID.forceOutBy;
            // that.DataListImgID = response.data.data.picture;
            // that.BindingEditData(that.DataListCarparkID);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.LoadingDialog = false;
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    BindingEditData(transaction) {
      let that = this;

      that.qrImage = "https://carpark.onebangkok.com/info/" + transaction.logID;
      that.logId = transaction.logID;
      that.ticket = transaction.ticketNo;
      that.license = transaction.carNo;

      that.date = that.ChangeFormatDateOnly(transaction.logDate);
      that.time = that.ChangeFormatTime(transaction.entryDate);

      that.DataListCarparkID.vehicleType =
        transaction.vehicleType == "0" ? "Car" : "Motorcycle";
      that.DataListCarparkID.logDate = that.ChangeFormatDate(
        transaction.logDate
      );
      that.DataListCarparkID.entryDate = that.ChangeFormatDate(
        transaction.entryDate
      );
      that.DataListCarparkID.parkTime =
        transaction.parkTime == ":" ? "" : transaction.parkTime;
      // console.log(picture);
      // if (picture.length > 0) {
      //   that.ImageList = picture;
      // }
      that.TransactionCarparkDialog = true;
      that.getDataTransactionCarparkByLogIDImage(that.logId);
    },

    getDataTransactionCarparkByLogIDImage(id) {
      let that = this;
      that.DataListImgID = [];
      that.ImageList = [];
      let temp = {
        logid: id,
      };
      axios
        .post(
          `${that.urlCarpark}TransactionCarpark/getDataTransactionCarparkImagesByLogID`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            // that.DataListCarparkID = response.data.data.transaction;
            that.DataListImgID = response.data.data;
            // console.log(that.DataListImgID);
            if (that.DataListImgID.length > 0) {
              that.ImageList = that.DataListImgID;
            }
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.LoadingDialog = false;
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    async ExportTransactionCarpark() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        logEntry: self.logEntry == "" ? null : self.logEntry,
        carNo: self.carNo == "" ? null : self.carNo,
        entryDateStart: self.entryDateStart == "" ? null : self.entryDateStart,
        entryTimeStart:
          self.startTimeEntry == null ? null : self.startTimeEntry,
        entryDateEnd: self.entryDateEnd == "" ? null : self.entryDateEnd,
        entryTimeEnd: self.endTimeEntry == null ? null : self.endTimeEntry,
        exitDateStart: self.exitDateStart == "" ? null : self.exitDateStart,
        exitTimeStart: self.startTimeExit == null ? null : self.startTimeExit,
        exitDateEnd: self.exitDateEnd == "" ? null : self.exitDateEnd,
        exitTimeEnd: self.endTimeExit == null ? null : self.endTimeExit,
        vehicleType:
          self.vehicleType == "" || self.vehicleType == null
            ? null
            : self.vehicleType == "Car"
            ? 0
            : 1,
        memberType:
          self.memType == "Member" ? 1 : self.memType == "Visitor" ? 0 : null,
        ticketNo: self.ticketNo == "" ? null : self.ticketNo,
        terminalEntry: self.terminalEntry == "" ? null : self.terminalEntry,
        tenantID: self.SearchTenant == "" ? null : self.SearchTenant,
        statusLog:
          self.statusLog == "" || self.statusLog == null
            ? null
            : self.statusLog == "ยังอยู่ในระบบ"
            ? 0
            : 1,
      };
      await axios
        .post(`${self.url}TransactionCarpark/exportTransactionCarpark`, temp, {
          responseType: "blob", // แจ้ง Axios ว่าต้องการรับข้อมูลในรูปแบบ Blob (ไฟล์)
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const now = new Date();
          const date = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const time = `${String(now.getHours()).padStart(2, "0")}:${String(
            now.getMinutes()
          ).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
          const dateTime = `${date} ${time}`;

          // สร้างลิงก์ในการดาวน์โหลดไฟล์
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "TransactionCarpark " + dateTime + ".xlsx"
          ); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
          document.body.appendChild(link);
          link.click(); // คลิกเพื่อดาวน์โหลดไฟล์
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Download failed:", err))
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    base64ToBlob(base64, type = "application/octet-stream") {
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr], { type: type });
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}
.header-table-center-css {
  text-align: center;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

.input-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.parking-img {
  width: 100%;
  height: 220px;
  border-radius: 8px;
  transition: 0.25s ease;
  object-fit: cover;
}

.parking-img:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.image-dialog {
  position: relative;
  /* background: black; */
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  backdrop-filter: blur(6px);
  z-index: 10;
}

.preview-img {
  max-height: 85vh;
  border-radius: 10px;
  transition: 0.25s ease;
}

.preview-img:hover {
  transform: scale(1.02);
}
</style>
